module.exports = __webpack_public_path__ + "static/media/Angie Whitaker Headshot Web_1591180091909.5f9e815c.jpg";